<template lang="pug">
theme-provider.h-100(:theme="{ ...theme }")
  pr-global#app.h-100
    aligns
    error(v-if="error")
    splash(v-if="splash")

    plugins
    platform

    player
    #videoplane
    background

    worker
</template>

<script>
import { ThemeProvider } from "vue-styled-components"
import { mapState } from "vuex"
import init from "@/init"

import { error, splash, platform, background, player, worker, aligns } from "@/components/core"
import plugins from "@/components/plugins/plugins.vue"

export default {
  name: "app",
  components: {
    ThemeProvider,
    error,
    splash,
    plugins,
    platform,
    background,
    player,
    worker,
    aligns
  },
  computed: {
    ...mapState(["error", "splash", "theme"])
  },
  created() {
    init
      .mount()
      .then(() => this.fetchLocales())
      .then(() => this.fetchTheme())
      .then(() => __.platform.syncData())
      .then(data => {
        if (!data) return false
        _$.vue.$emit("ready", true)
      })
      .catch(err => this.$store.commit("error", err))
  },
  methods: {
    fetchTheme() {
      return fetch("/theme/config.json".host("v2"))
        .then(response => response.json())
        .then(data => this.$store.commit("theme", data))
        .catch(() => true)
    },
    fetchLocales() {
      this.$i18n._locales.forEach(code => {
        return fetch(`/locales/${code}.json`.host("v2"))
          .then(response => response.json())
          .then(data => this.$i18n.setLocaleMessage(code, Object.assign(this.$i18n.messages[code], data)))
          .catch(() => true)
      })
      return true
    }
  }
}
</script>

<style lang="scss"></style>
